<template>
  <div class="bg323232 df fDC aic">
    <div class="main_width df pt50 pb40">
      <div class="w33b pr10">
        <div class="bb979797 bw2 hl14 cFEFEFE f16 mb15 hl40 tl">联系我们</div>
        <div class="tl c979797">公司名称：杭州豆伴信息科技有限公司</div>
        <div class="tl c979797 df"><span class="f00a">公司地址：</span>
          <p class="pr20">浙江省杭州市江干区中豪五福天地2幢1001-2室</p>
        </div>
        <div class="tl c979797">公司电话：4000-963-100</div>
        <div class="tl c979797">公司邮箱：kf@dooban.cn</div>
      </div>
      <div class="w18b pr10">
        <div class="bb979797 bw2 hl14 cFEFEFE f16 mb15 hl40 tl">招商信息</div>
        <!-- <a class="db tl c979797 dp-text-c-primary-hover cp" @click="handleCustomerBtn">代理招商</a> -->
        <a class="db tl c979797 dp-text-c-primary-hover cp" @click="handleCustomerBtn">平台输出</a>
      </div>
      <div class="w25b pr10 tl">
        <div class="bb979797 bw2 hl14 cFEFEFE f16 mb15 hl40">友情链接</div>
        <a href="https://csnta.smm.cn/" target="_blank" class="db c979797 dp-text-c-primary-hover cp">上海有色协会</a>
        <a href="http://www.shcpe.com.cn/index.html" target="_blank" class="db c979797 dp-text-c-primary-hover cp">上海票交所</a>
        <a href="http://www.piaoyou123.com/" target="_blank" class="db c979797 dp-text-c-primary-hover cp">票友之家</a>
        <a href="https://www.vanyang.online" target="_blank" class="db c979797 dp-text-c-primary-hover cp">万洋快贴宝</a>
        <!-- <a href="https://www.luzhukt.com" target="_blank"><div class="db c979797 dp-text-c-primary-hover cp">逐鹿快贴宝</div></a> -->
      </div>
      <div class="w25b pr10 tl">
        <div class="bb979797 bw2 hl14 cFEFEFE f16 mb15 hl40">网站地图</div>
        <router-link to="/" class="db c979797 cp dp-text-c-primary-hover">首页</router-link>
        <router-link to="/ApplicationDiscount" class="db c979797 cp dp-text-c-primary-hover">银票快贴</router-link>
        <router-link to="/BusinessTicketDiscount" class="db c979797 cp dp-text-c-primary-hover">商票速融</router-link>
        <router-link to="/Information" class="db c979797 cp dp-text-c-primary-hover">承兑汇票资讯</router-link>
        <router-link to="/UserInfoChange" class="db c979797 cp dp-text-c-primary-hover">账户中心</router-link>
        <router-link to="/PlatformIntroduce" class="db c979797 cp dp-text-c-primary-hover">产品介绍</router-link>
        <router-link to="/Notice" class="db c979797 cp dp-text-c-primary-hover">公告中心</router-link>
      </div>
    </div>
    <div class="cfff bt979797 w100b hl40 dn">技术支持：上海豆伴互联网金融信息服务有限公司</div>
    <div class="cfff bt979797 w100b hl40"><img class="w16 mr5 bottom-gn-img" src="~@/assets/img/home/gongan.png" /><a href="http://www.beian.gov.cn/portal/registerSystemInfo?spm=5176.19720258.J_9220772140.112.e9392c4aMB9lQr" class="cfff mr10 dp-text-c-primary-hover">浙公网安备 33010202001776号</a>备案号：<a href="http://beian.miit.gov.cn/" class="cfff dp-text-c-primary-hover">浙ICP备18018573号</a></div>
  </div>
</template>

<script>
import store from '@/store/store';
export default {
  store, // 引用
  name: "bottomMenu",
  data () {
    return {
    }
  },
  created () {
    // console.log("teshd", this.$store.state.menuList)
  },
}
</script>

<style scoped>
.bottom-gn-img {
  width: 16px;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/module/Bottom.vue